import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoyaltyConfigForm } from '../features/loyalty';

export default function LoyaltyConfig() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== 'admin') return <Navigate to="/home" replace />;
  return <LoyaltyConfigForm />;
}
